import { Button } from '@cian/button-component';
import * as React from 'react';

import { Like, PhoneHangUp } from '../../../../icons';
import * as iconStyles from '../../../../icons/styles/styles.css';
import { trackFeedbackOptionClick } from '../../../tracking';
import * as styles from '../styles/styles.css';

interface IQuestionBlockProps {
  onYesButtonClick(): void;
  onNoButtonClick(): void;
  onDidNotPickUpPhoneButtonClick(): void;
}

export function QuestionBlock(props: IQuestionBlockProps) {
  const { onNoButtonClick, onYesButtonClick, onDidNotPickUpPhoneButtonClick } = props;

  const handleNoButtonClick = () => {
    trackFeedbackOptionClick('not_confirmed');

    onNoButtonClick();
  };

  const handleYesButtonClick = () => {
    trackFeedbackOptionClick('confirmed');

    onYesButtonClick();
  };

  const handleDidNotPickUpPhoneButtonClick = () => {
    trackFeedbackOptionClick('no_answer');

    onDidNotPickUpPhoneButtonClick();
  };

  return (
    <div className={styles['question_block']}>
      Подтвердилась ли информация, указанная в объявлении?
      <div className={styles['actions']}>
        <Button theme="ghost" className={styles['action_button']} onClick={handleNoButtonClick}>
          <div className={styles['button_content']}>
            <Like className={iconStyles['rotate_180']} />
            <span className={styles['button_text']}>Нет</span>
          </div>
        </Button>

        <Button theme="ghost" className={styles['action_button']} onClick={handleYesButtonClick}>
          <div className={styles['button_content']}>
            <Like />
            <span className={styles['button_text']}>Да</span>
          </div>
        </Button>

        <Button theme="ghost" className={styles['action_button']} onClick={handleDidNotPickUpPhoneButtonClick}>
          <div className={styles['button_content']}>
            <PhoneHangUp />
            <span className={styles['button_text']}>Не взяли трубку</span>
          </div>
        </Button>
      </div>
    </div>
  );
}
